"use strict";

exports.__esModule = true;
exports.SkeletonWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const pulseFade = (0, _styledComponents.keyframes)`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
`;

const isCircle = ({
  width,
  height,
  circle
}) => {
  if (!!width && !!height && !!circle) return true;
  return false;
};

const SkeletonWrapper = (0, _styledComponents.default)(({
  children,
  width,
  height,
  count,
  circle,
  duration,
  delay,
  iterations,
  color,
  contrast,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", { ...otherProps,
  children: children
}))`
    display: inline-block;
    width: 100%;
    max-width: 100%;
    height: 100%;
    background-color: ${({
  theme,
  contrast
}) => contrast ? theme.colors.skeleton.contrast.background : theme.colors.skeleton.background};
    animation-name: ${pulseFade};
    animation-duration: 1.75s;
    animation-timing-function: ease-in-out;
    animation-delay: 3s;
    animation-iteration-count: infinite;
    font-size: inherit;
    margin-bottom: ${({
  count
}) => count > 1 ? 'inherit' : 0};
    border-radius: ${props => isCircle(props) ? '50%' : props.theme.borderRadius.small};
`;
exports.SkeletonWrapper = SkeletonWrapper;